import React from 'react';

function Footer() {
  return (
    <div className="fixed bottom-0 w-screen py-2 text-center">
      <p className="text-xs">
        &copy; 2022
        {' '}
        <strong>Rubie&apos;s Studio</strong>
        {' '}
        by Nursyahrina &hearts;
      </p>
    </div>
  );
}

export default Footer;
